import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 1140px;
  height: 100vh;
  padding: 100px 40px 40px 40px;
`;

export default Container;
